<template>
  <div class="transactions-actions-bar">
    <slot name="statsBlock">
      <stats-block
        v-if="hasTotalStats"
        :has-stats="hasStats"
        :is-statistic-opened="isStatisticOpened"
        :stats-abac="statsAbac"
        @toggleStatistic="toggleStatistic"
        :stats="stats"
        :bills="bills"
      ></stats-block>
    </slot>
    <div
      class="transactions-actions-bar__group transactions-actions-bar__group--filter"
      v-if="hasFilter"
    >
      <slot name="extraFilter"></slot>
      <actions-filter-button
        class="transactions-actions-bar__filter-action"
        @click="toggleFilters"
        :is-filter-active="isFilterActive"
        :is-filter-opened="isFiltersOpened"
      ></actions-filter-button>
    </div>
    <slot name="plainFilter"></slot>
    <require-access
      :data="exportAbac.data"
      :action="exportAbac.action"
      v-if="hasExport"
    >
      <export-button
        class="transactions-actions-bar__action transactions-actions-bar__action--export"
        @exportCalled="handleExportAction"
        :export-options="exportOptions"
      ></export-button>
    </require-access>
    <refresh-button
      v-if="hasRefresh"
      class="transactions-actions-bar__action transactions-actions-bar__action--refresh"
      @click="handleRefreshAction"
    ></refresh-button>
    <div
      class="transactions-actions-bar__specific-actions"
      :class="{
        'transactions-actions-bar__specific-actions--to-right':
          specificActionsToRight,
      }"
    >
      <slot name="specificActions"></slot>
    </div>
  </div>
</template>

<script>
import {
  $on,
  $off,
  $once,
  $emit,
} from '../../../../../../utils/gogocodeTransfer'
import ExportButton from '@vue-app/components/base/button/ExportButton.vue'
import RefreshButton from '@vue-app/components/base/button/RefreshButton.vue'
import TransactionTypesSelect from '@vue-app/components/company/analytics/filter/TransactionTypesSelect.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

import ActionsFilterButton from '@vue-app/components/company/transactions/shared/transactions-page-controls/actions-bar/parts/ActionsFilterButton.vue'
import { Stats } from '@js-app/entities/transaction/Stats'
import StatsBlock from '@vue-app/components/company/transactions/shared/transactions-page-controls/actions-bar/parts/StatsBlock.vue'

export default {
  name: 'TransactionsActionsBar',
  components: {
    StatsBlock,
    ActionsFilterButton,
    RequireAccess,
    TransactionTypesSelect,
    RefreshButton,
    ExportButton,
  },
  props: {
    bills: {
      type: Boolean,
      default: false,
    },
    specificActionsToRight: {
      type: Boolean,
      default: true,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    hasStats: {
      type: Boolean,
      default: false,
    },
    hasTotalStats: {
      type: Boolean,
      default: true,
    },
    statsAbac: {
      type: Object,
      default() {
        return {
          action: '',
          data: '',
        }
      },
    },
    hasExport: {
      type: Boolean,
      default: true,
    },
    exportAbac: {
      type: Object,
      default() {
        return { data: '', action: '' }
      },
    },
    exportOptions: {
      type: Array,
      default() {
        return []
      },
    },
    isStatisticOpened: {
      type: Boolean,
      default: false,
    },
    isFiltersOpened: {
      type: Boolean,
      default: false,
    },
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    stats: {
      type: [Stats, Object],
      default() {
        return new Stats()
      },
    },
    hasRefresh: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleExportAction(exportType) {
      $emit(this, 'export', exportType)
    },
    handleRefreshAction() {
      $emit(this, 'refresh')
    },
    toggleFilters() {
      $emit(this, 'toggleFilters', !this.isFiltersOpened)
    },
    toggleStatistic() {
      $emit(this, 'toggleStatistic', !this.isStatisticOpened)
    },
  },
  emits: ['export', 'toggleFilters', 'toggleStatistic', 'refresh'],
}
</script>

<style lang="scss" scoped>
.transactions-actions-bar {
  display: flex;
  align-items: stretch;
  &__group {
    padding: 7px 15px 9px 24px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;

    &--filter {
      &:first-child {
        margin-left: 0;
      }

      margin-right: auto;
      margin-left: 15px;
    }
  }

  &__action {
    margin-left: 15px;
  }

  &__filter-action {
    &:first-child {
      margin-left: 0;
    }
  }

  &__specific-actions {
    display: flex;
    align-items: center;
    margin-left: 15px;

    // &--to-right {
    //   margin-left: auto;
    // }

    &:empty {
      margin-left: 0;
    }
  }
}
@media screen and (max-width: 992px) {
  .transactions-actions-bar {
    flex-wrap: wrap;
    &__group {
      &--statistic {
        width: 100%;
        margin-bottom: 10px;
      }

      &--filter {
        width: 100%;
        margin-left: 0 !important;
        margin-bottom: 10px;
        background: transparent;
        display: flex;
        justify-content: space-between;
        padding: 0;
      }

      &-toggle {
        margin-left: auto;
      }
    }

    &__icon-action {
      &--filter {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 33px;
        width: calc(50% - 7px);
        height: 44px;
        background: #fff;
        border-radius: 8px;
        margin-left: 0;
        border: 1px solid transparent;

        &.active {
          border: 1px solid #64748B;
          box-shadow: 0px 8px 20px rgba(225, 235, 253, 0.38);
        }
      }

      &-text {
        display: block;
      }
    }

    &__action {
      &--export {
        margin-left: 0;
        width: calc(50% - 10px);
        margin-right: 20px;
        height: 44px;
      }

      &--refresh {
        margin-left: 0;
        width: calc(50% - 10px);
        height: 44px;
      }
    }
  }
  .operation-types {
    width: calc(50% - 7px);
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 33px;
    background: #ffffff;
    border-radius: 8px;
  }
}
</style>
